import { Box, Button, Link, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { routesGuest } from '../../../consts'
import { acceptCookieConsent, hasAcceptedCookieConsent } from '../../../utils/cookieConsent'
import { COLORS } from '../../../styles/variables'

const bannerSx = {
  position: 'fixed',
  left: '50%',
  bottom: 'calc(16px + env(safe-area-inset-bottom, 0px))',
  transform: 'translateX(-50%)',
  zIndex: 1300,
  maxWidth: 'min(640px, calc(100vw - 32px))',
  width: { xs: 'calc(100vw - 32px)', sm: 'max-content' },
  px: 2,
  py: 1.5,
  borderRadius: 2,
  bgcolor: COLORS.CERULEAN,
  boxShadow: '0 6px 20px rgba(10, 158, 222, 0.35)',
}

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(() => !hasAcceptedCookieConsent())

  if (!visible) {
    return null
  }

  const handleAccept = () => {
    acceptCookieConsent()
    setVisible(false)
  }

  return (
    <Box sx={bannerSx} role="dialog" aria-label="Уведомление об использовании cookie">
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'center', sm: 'center' }}
        gap={1.5}
      >
        <Typography
          variant="body2"
          sx={{
            color: COLORS.WHITE,
            fontWeight: 500,
            textAlign: { xs: 'center', sm: 'left' },
            maxWidth: { sm: 420 },
          }}
        >
          Мы используем файлы cookie, чтобы сайт работал корректно. Продолжая пользоваться сайтом, вы
          соглашаетесь с этим.{' '}
          <Link
            component={RouterLink}
            to={`/${routesGuest.COOKIES.path}`}
            underline="always"
            sx={{ color: COLORS.WHITE, fontWeight: 600 }}
          >
            Подробнее
          </Link>
        </Typography>
        <Button
          variant="follow"
          size="small"
          onClick={handleAccept}
          sx={{
            flexShrink: 0,
            alignSelf: { xs: 'stretch', sm: 'auto' },
            width: { xs: '100%', sm: 'auto' },
            bgcolor: COLORS.WHITE,
            color: COLORS.NICE_BLUE,
            borderColor: COLORS.WHITE,
            fontWeight: 600,
            '&:hover': {
              bgcolor: COLORS.CATSKILL_WHITE,
              borderColor: COLORS.CATSKILL_WHITE,
            },
          }}
        >
          Принять
        </Button>
      </Stack>
    </Box>
  )
}
